/**
 * Go Sport - Recommandations nutrition et compléments
 */

export const PRE_SESSION_FOOD = {
  twoHours: {
    low: ['Riz + poulet', 'Pâtes + légumes', "Flocons d'avoine"],
    mid: ['Glucides complexes + protéines maigres', 'Patate douce + poisson', 'Quinoa + légumineuses'],
    high: ['Plan nutrition personnalisé (coach IA)', 'Repas structuré macro-optimisé'],
  },
  thirtyMin: [
    'Banane', 'Dattes', 'Barre énergétique naturelle', 'Eau (500 ml minimum)',
  ],
};

export const POST_SESSION_FOOD = {
  thirtyMin: {
    low: ['Banane + eau', 'Smoothie fruits', 'Lait chocolaté'],
    mid: ['Shake protéiné', 'Yaourt grec + fruits', 'Œufs + toast'],
    high: ['30-40g protéines rapides', 'Glucides rapides', 'Créatine post-workout'],
  },
  twoHours: 'Repas complet équilibré (protéines + glucides complexes + légumes)',
};

export const SUPPLEMENTS_PRE = [
  {
    levels: [1, 2, 3],
    objectives: ['wellbeing'],
    items: [
      { name: 'Magnésium', dosage: '300-400mg', info: 'Réduit la fatigue et les crampes' },
      { name: 'Vitamine D', dosage: '1000-2000 UI', info: 'Santé osseuse et immunitaire' },
      { name: 'Oméga-3', dosage: '1-2g', info: 'Anti-inflammatoire, santé cardiovasculaire' },
    ],
  },
  {
    levels: [4, 5, 6],
    objectives: ['endurance'],
    items: [
      { name: 'BCAA', dosage: '5-10g', info: "Réduction fatigue musculaire pendant l'effort" },
      { name: 'Créatine', dosage: '3-5g', info: 'Améliore la force et la puissance' },
      { name: 'Magnésium', dosage: '300-400mg', info: 'Prévient les crampes' },
    ],
  },
  {
    levels: [7, 8, 9, 10],
    objectives: ['performance'],
    items: [
      { name: 'Protéines whey', dosage: '20-30g', info: 'Synthèse protéique optimale' },
      { name: 'Créatine', dosage: '5g', info: 'Rechargement ATP, force explosive' },
      { name: 'Pré-workout', dosage: 'Selon produit', info: '⚠️ Précaution avec traitement TDAH (stimulants)' },
    ],
  },
  {
    levels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    objectives: ['weight_loss'],
    items: [
      { name: 'L-Carnitine', dosage: '1-2g', info: 'Aide au transport des acides gras' },
      { name: 'Thé vert (extrait)', dosage: '250-500mg', info: 'Boost métabolique léger' },
      { name: 'Protéines', dosage: '20-30g', info: 'Satiété et préservation musculaire' },
    ],
  },
];

export const SUPPLEMENTS_POST = [
  { name: 'Whey protéine', timing: 'Immédiat', benefit: 'Récupération musculaire' },
  { name: 'Créatine', timing: 'Dans les 2h', benefit: 'Rechargement ATP' },
  { name: 'Magnésium', timing: 'Soir', benefit: 'Qualité du sommeil + récupération' },
  { name: 'Oméga-3', timing: 'Avec repas', benefit: 'Anti-inflammatoire' },
  { name: 'ZMA (zinc, magné, B6)', timing: 'Au coucher', benefit: 'Récupération nocturne' },
];

export const HEALTH_WARNINGS = {
  TDAH_stimulant: [
    'Surveiller la fréquence cardiaque',
    'Hydrater++ (eau supplémentaire)',
    'Éviter séance si FC > 100bpm au repos',
  ],
  hypertension: [
    'Privilégier intensité modérée',
    'Arrêter si maux de tête ou vertiges',
  ],
  none: [],
};

export function getHydrationMl(level) {
  return 300 + (level * 50);
}

export function getPostHydrationMl(caloriesBurned) {
  return Math.round(caloriesBurned * 1.5);
}

export function getPreFoodForLevel(level) {
  if (level <= 4) return PRE_SESSION_FOOD.twoHours.low;
  if (level <= 7) return PRE_SESSION_FOOD.twoHours.mid;
  return PRE_SESSION_FOOD.twoHours.high;
}

export function getPostFoodForLevel(level) {
  if (level <= 4) return POST_SESSION_FOOD.thirtyMin.low;
  if (level <= 7) return POST_SESSION_FOOD.thirtyMin.mid;
  return POST_SESSION_FOOD.thirtyMin.high;
}

export function getSupplementsForProfile(level, objective) {
  const match = SUPPLEMENTS_PRE.find(s =>
    s.levels.includes(level) && s.objectives.includes(objective)
  );
  return match ? match.items : SUPPLEMENTS_PRE[0].items;
}
